'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'star';
var width = 576;
var height = 512;
var aliases = [11088,61446];
var unicode = 'f005';
var svgPathData = ['M29.4 171.9c-.9 2.9-.2 6 1.9 8.1L145.7 294.6c3.6 3.6 5.3 8.7 4.5 13.8L125 468.3c-.5 3 .8 6 3.2 7.7s5.6 2 8.3 .7l144.3-73.4c4.6-2.3 10-2.3 14.5 0l144.3 73.4c2.7 1.4 5.9 1.1 8.3-.7s3.7-4.7 3.2-7.7L425.9 308.4c-.8-5.1 .9-10.2 4.5-13.8L544.8 180.1c2.1-2.1 2.9-5.3 1.9-8.1s-3.4-5-6.4-5.4L380.5 141.1c-5-.8-9.4-4-11.7-8.5L295.2-11.6c-1.4-2.7-4.1-4.4-7.1-4.4s-5.8 1.7-7.1 4.4L207.4 132.6c-2.3 4.6-6.7 7.7-11.7 8.5L35.7 166.5c-3 .5-5.4 2.6-6.4 5.4z', 'M288.1-32c-9 0-17.3 5.1-21.4 13.1L193.1 125.3 33.2 150.7c-8.9 1.4-16.3 7.7-19.1 16.3s-.5 18 5.8 24.4l114.4 114.5-25.2 159.9c-1.4 8.9 2.3 17.9 9.6 23.2s16.9 6.1 25 2L288.1 417.6 432.4 491c8 4.1 17.7 3.3 25-2s11-14.2 9.6-23.2L441.7 305.9 556.1 191.4c6.4-6.4 8.6-15.8 5.8-24.4s-10.1-14.9-19.1-16.3L383 125.3 309.5-18.9c-4.1-8-12.4-13.1-21.4-13.1zm80.7 164.6c2.3 4.6 6.7 7.7 11.7 8.5l159.9 25.4c3 .5 5.4 2.6 6.4 5.4s.2 6-1.9 8.1L430.4 294.6c-3.6 3.6-5.3 8.7-4.5 13.8l25.2 159.9c.5 3-.8 6-3.2 7.7s-5.7 2-8.3 .7L295.3 403.3c-4.6-2.3-9.9-2.3-14.5 0L136.5 476.7c-2.7 1.4-5.9 1.1-8.3-.7s-3.7-4.7-3.2-7.7l25.2-159.9c.8-5.1-.9-10.2-4.5-13.8L31.3 180.1c-2.1-2.1-2.9-5.3-1.9-8.1s3.4-5 6.4-5.4l159.9-25.4c5.1-.8 9.4-4 11.7-8.5L281-11.6c1.4-2.7 4.1-4.4 7.1-4.4s5.8 1.7 7.1 4.4l73.6 144.2z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStar = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;